<div class="stacked-bar-chart-wrapper fw fh">
    <div class="stacked-bar-chart-cntnr fw fh"
        *ngIf="!showNoData">
        <div class="y-axis-label fh">
            <div class="y-label">
            </div>
        </div>
        <div class="bar fh">
            <div class="bar-split">
                <div class="bar-inner"
                    *ngFor="let quantityArr of plotData?.quantity; let first = first; let last = last;let j=index;"
                    [style.height]="quantityArr?.componentTotal>0?(showTotalForBar?((quantityArr?.total*100)/plotData?.componentMaxVal)+'%' :
                    ((quantityArr?.componentTotal*100)/plotData?.componentMaxVal)+'%'):'0%'"
                    (mouseenter)="hoveredItem=quantityArr"
                    (mouseleave)="hoveredItem=null"
                    [popover]="popTemplate"
                    containerClass="line-multi-bar-popup"
                    triggers="mouseenter:mouseleave"
                    container="body"
                    placement="top"
                    viewport="{selector:'body', padding-right: 5px}"
                    @fillUp>

                    <div class="component fw"
                        *ngFor="let component of quantityArr?.value"
                        [ngClass]="component?.unit"
                        [style.height]="showTotalForBar?((component?.value*100)/quantityArr?.total)+'%' : ((component?.value*100)/quantityArr?.componentTotal)+'%'">
                        <div class="component-value fw">
                        </div>
                    </div>
                    <div class="x-type-label fw ellipses"
                        title="{{quantityArr?.type}}">
                        <span>{{quantityArr?.type}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="no-data fw fh"
        *ngIf="showNoData">
        <div class="info-wrapper">
            <span>{{'waste_db.no_waste' | translate}}</span>
        </div>
    </div>

    <ng-template #popTemplate>
        <div class="fw fh popup-quantity">
            <div class="header">
                <span>{{popOverArr?.name}}</span>
            </div>
            <div class="quantity-dtls-table-wrapper fw">
                <div class="table-header fw">
                    <div class="rm cell"
                        *ngIf="showRM">
                        <span>{{'common.rm' | translate}}</span>
                    </div>
                    <div class="pm cell"
                        *ngIf="showPM">
                        <span>{{'common.pm' | translate}}</span>
                    </div>
                </div>

                <div class="component-type"
                    *ngFor="let unit of popOverArr?.quantityWaste;let j=index;"
                    [hidden]="unit.rmValue === 0 && unit.pmValue === 0">
                    <ng-container *ngIf="unit.rmValue !== 0 || unit.pmValue !== 0">
                        <div class="label cell ellipses">
                            <div class="unit {{unit?.unit}}"> {{unit.unitValue}} </div>
                        </div>
                        <div class="cell val rm">
                            {{unit.rmValue | localDecimalPipe}}
                        </div>
                        <div class="cell val pm">
                            {{unit.pmValue | localDecimalPipe}}
                        </div>
                    </ng-container>
                </div>

                <div class="no-data-hovered"
                    *ngIf="popOverArr?.quantityWaste && popOverArr?.quantityWaste.length === 0">
                    {{'waste_db.no_waste' | translate}}
                </div>
            </div>
        </div>
    </ng-template>
</div>